import Close from "../../../assets/images/icons/close.svg";
import { Images } from "../../Common/Images";

const GuestThirtyMinModal = ({ onClose, context }) => {
    const {
        t,
        guestErrors,
        guestName30mit,
        setGuestName30mit,
        guestLastName30mit,
        setGuestLastName30mit,
        guestEmail30mit,
        setGuestEmail30mit,
        identificatoin30mit,
        setIdentification30mit,
        clearGuestFieldError,
        validateGuestFields,
        pendingGuestBooking,
        executeRandomSpaceBooking,
        resetForm,
    } = context;

    return (
        <div
            className="modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="dateModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
                <div className="modal-content modal-radius">
                    <div className="modal-body">
                        <div className="close-modal">
                            <a className="close-modal">
                                <img src={Close} alt="Close" onClick={resetForm} />
                            </a>
                        </div>
                        <div className="pt-2">
                            <h5 className="popup-title">Guest Details</h5>
                        </div>

                        <div className="form-row mb-3">
                            <label className="popup-inner-title m-0">First Name*</label>
                            <input
                                type="text"
                                placeholder="First Name"
                                className={`form-control ${guestErrors.thirtyMin.firstname ? "error-form" : ""} ${!guestErrors.thirtyMin.firstname && guestName30mit ? "success-validation" : ""}`}
                                value={guestName30mit}
                                onChange={(e) => {
                                    setGuestName30mit(e.target.value);
                                    clearGuestFieldError("thirtyMin", "firstname");
                                }}
                            />
                            {guestErrors.thirtyMin.firstname && (
                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.thirtyMin.firstname}</p></div>
                            )}
                        </div>

                        <div className="form-row mb-3">
                            <label className="popup-inner-title m-0">Last Name*</label>
                            <input
                                type="text"
                                placeholder="Last Name"
                                className={`form-control ${guestErrors.thirtyMin.lastname ? "error-form" : ""} ${!guestErrors.thirtyMin.lastname && guestLastName30mit ? "success-validation" : ""}`}
                                value={guestLastName30mit}
                                onChange={(e) => {
                                    setGuestLastName30mit(e.target.value);
                                    clearGuestFieldError("thirtyMin", "lastname");
                                }}
                            />
                            {guestErrors.thirtyMin.lastname && (
                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.thirtyMin.lastname}</p></div>
                            )}
                        </div>

                        <div className="form-row mb-3">
                            <label className="popup-inner-title m-0">Email address*</label>
                            <div className="position-relative">
                            <input
                                type="email"
                                placeholder="___@____"
                                className={`form-control ${guestErrors.thirtyMin.email ? "error-form" : ""} ${!guestErrors.thirtyMin.email && guestEmail30mit ? "success-validation" : ""}`}
                                value={guestEmail30mit}
                                onChange={(e) => {
                                    setGuestEmail30mit(e.target.value);
                                    clearGuestFieldError("thirtyMin", "email");
                                }}
                            />
                            <img
                                src={Images.EmailMessage}
                                alt=""
                                // Hidden while the input shows its own right-side icon - the red error icon
                                // (error-form) or the green success tick (success-validation) - so they don't overlap
                                className={`form-icon ${guestErrors.thirtyMin.email || guestEmail30mit ? "d-none" : ""}`}
                            />
                            {guestErrors.thirtyMin.email && (
                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.thirtyMin.email}</p></div>
                            )}
                            </div>
                        </div>

                        <div className="form-row mb-3">
                            <label className="popup-inner-title m-0">Identification number (optional)</label>
                            <input
                                type="text"
                                placeholder="Identification number (optional)"
                                className="form-control"
                                value={identificatoin30mit}
                                onChange={(e) => setIdentification30mit(e.target.value)}
                            />
                        </div>

                        <div className="tags-btn mt-4">
                            <button
                                type="submit"
                                className="w-100 min-height-56 selected"
                                onClick={async (e) => {
                                    e.preventDefault();

                                    const isValid = validateGuestFields(
                                        {
                                            name: guestName30mit,
                                            surname: guestLastName30mit,
                                            email: guestEmail30mit
                                        },
                                        "thirtyMin"
                                    );

                                    if (!isValid) {
                                        return;
                                    }

                                    if (!pendingGuestBooking) return;

                                    await executeRandomSpaceBooking(
                                        pendingGuestBooking.zoneId,
                                        pendingGuestBooking.bookingDateStr,
                                        pendingGuestBooking.VehicleTypeId,
                                        pendingGuestBooking.fuelId,
                                        pendingGuestBooking.vehicleShareableId,
                                        pendingGuestBooking.vehicleAccessibleId,
                                        pendingGuestBooking.vehicleRegistrationId,
                                        pendingGuestBooking.isGuestFlag,
                                        {
                                            guestName30mit,
                                            guestLastName30mit,
                                            guestEmail30mit,
                                            spotName: pendingGuestBooking.spotName,
                                            startTime: pendingGuestBooking.startTime,
                                            endTime: pendingGuestBooking.endTime
                                        }
                                    );

                                    resetForm();
                                    onClose();
                                }}
                            >
                                {t("confirm")}
                            </button>
                        </div>

                        <div className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3">
                            <a type="button" onClick={resetForm()}>
                                {t("cancel")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuestThirtyMinModal;
